<template>
  <div class="contract-compute-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="计算方式" prop="method">
            <el-select
              v-model="formDate.method"
              placeholder="请选择计算方式"
              clearable
              class="auto-width"
            >
              <el-option
                v-for="item in methodOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="原始数据" prop="a">
            <el-input v-model="formDate.a" placeholder="请输入非负整数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="变量数据" prop="x">
            <el-input v-model="formDate.x" placeholder="请输入非负整数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="formDate.result" label="result" prop="result">
            <el-input v-model="formDate.result" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handlePedersenVerify()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        method: null,
        chainId: '',
        userId: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        a: null,
        x: null
      },
      methodOption: [
        {
          label: '承诺加数值',
          value: 1
        },
        {
          label: '承诺加承诺',
          value: 2
        },
        {
          label: '承诺减数值',
          value: 3
        },
        {
          label: '承诺减承诺',
          value: 4
        },
        {
          label: '承诺乘数值',
          value: 5
        }
      ],
      editRules: {
        method: [{ required: true, message: '请选择计算方式', trigger: 'blur' }],
        a: [
          { required: true, message: '请输入原始数据', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
        ],
        x: [
          { required: true, message: '请输入变量数据', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.formDate.chainId = val
      }
    }
  },
  mounted() {
    this.formDate.chainId = this.$store.state.computing.chainId
  },
  methods: {
    handlePedersenVerify() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.formDate.a = Number(this.formDate.a)
          this.formDate.x = Number(this.formDate.x)
          this.$apis.bulletproofs.contractCompute(this.formDate).then(res => {
            if (res) {
              this.formDate.result = res.data.result
              localStorage.setItem('provemethod', this.formDate.method)
              localStorage.setItem('contractCompute', JSON.stringify(res.data))
              this.$message.success('计算成功!')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.contract-compute-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
